import appStrings from '@/app/utility/string.utility';
export default {
  name: 'CrmProjectOtherSpec',
  props: {
    parentCrmProjectData: Object
  },
  data() {
    return {
      parent_value_set_id: null,
      unsubscribe: null,
      showModalComponent: false,
      showValueSetModal: false,
      editMode: false,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      projectId: null,
      widthType: null,

      latitude: null,
      longitude: null,
      defaultValue: {
        value: null,
        text: null
      },
      direction: {
        value: null,
        text: null
      },
      openSide: {
        value: null,
        text: null
      },
      frontWidth: null,
      frontWidthUnit: {
        value: null,
        text: null
      },
      backWidth: null,
      backWidthUnit: {
        value: null,
        text: null
      }
    };
  },
  mounted() {
    this.getUomClass();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode == true) {
          this.addEditCrmProjectOtherSpec();
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
    this.projectId = this.parentCrmProjectData.crm_project_id;
    this.getCrmProjectOtherSpec();
  },
  methods: {
    getCrmProjectOtherSpec() {
      const payload = {
        crmProjectId: this.projectId
      };
      this.loader = true;
      this.$store
        .dispatch('crmInventoryProperty/getCrmProjectOtherSpec', payload)
        .then(response => {
          this.loader = false;
          const results = response.data.data;
          this.projectId = results.crm_project_id;
          this.projectOtherSpecId = results.crm_project_other_specification_id;
          this.latitude = results.latitude;
          this.direction = {
            value: results.direction_value_code,
            text: results.direction_value_meaning
          };
          this.longitude = results.longitude;
          this.openSide = {
            value: results.open_side_value_code,
            text: results.open_side_value_meaning
          };
          this.frontWidth = results.front_road_width;
          this.frontWidthUnit = {
            value: results.front_road_uom_value_code,
            text: results.front_road_uom_value_meaning
          };
          this.backWidth = results.back_road_width;
          this.backWidthUnit = {
            value: results.back_road_uom_value_code,
            text: results.back_road_uom_value_meaning
          };
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addEditCrmProjectOtherSpec() {
      const payload = {
        back_road_width: this.backWidth,
        back_road_uom_value_code: this.backWidthUnit.value,
        direction_value_code: this.direction.value,
        front_road_width: this.frontWidth,
        front_road_uom_value_code: this.frontWidthUnit.value,
        crm_project_id: this.projectId,
        latitude: this.latitude,
        open_side_value_code: this.openSide.value,
        longitude: this.longitude,
        crm_project_other_specification_id: this.projectOtherSpecId
      };
      this.loader = true;
      this.$store
        .dispatch('crmInventoryProperty/addEditCrmProjectOtherSpec', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.showAlert = true;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            const results = response.data.data;
            this.projectOtherSpecId =
              results.crm_project_other_specification_id;
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    getUomClass() {
      this.$store
        .dispatch('template/getLOVBySetType', 'UOM_CLASS')
        .then(response => {
          if (response.status === 200) {
            const filterResult = response.data.data;
            const getValueAndText = filterResult.map(type => {
              return {
                value: type.value_code,
                text: type.value_meaning,
                detail_id: type.value_set_dtl_id
              };
            });
            this.intervalClass = getValueAndText.filter(
              item => item.value === 'LEN'
            );
          }
        });
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'Direction') {
        this.direction = {
          value: item.value_code,
          text: item.value_meaning
        };
      }
      if (this.vsetCode === 'Open_side') {
        this.openSide = {
          value: item.value_code,
          text: item.value_meaning
        };
      }
      if (this.vsetCode === 'UOM') {
        if (this.widthType === 'frontWidth') {
          this.frontWidthUnit = {
            value: item.value_code,
            text: item.value_meaning
          };
        } else if (this.widthType === 'backWidth') {
          this.backWidthUnit = {
            value: item.value_code,
            text: item.value_meaning
          };
        }
      }
    },
    openValueSetModal(vsetCode, widthType) {
      if (vsetCode === 'UOM') {
        this.parent_value_set_id = this.intervalClass[0].detail_id;
      }
      this.vsetCode = vsetCode;
      this.widthType = widthType;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode, widthType) {
      if (vsetCode === 'Direction') {
        this.direction = this.defaultValue;
      } else if (vsetCode === 'Open_side') {
        this.openSide = this.defaultValue;
      } else if (vsetCode === 'UOM') {
        if (widthType === 'frontWidth') {
          this.frontWidthUnit = this.defaultValue;
        } else if (widthType === 'backWidth') {
          this.backWidthUnit = this.defaultValue;
        }
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
